// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Mlvyq","card":"card--3ABx6","card-img":"card-img--3_0IO","card-title":"card-title--3dqsX"};